module.exports = __webpack_public_path__ + "@/assets/img/hellow_event.83506da8.png";